import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Atom, MagnifyingGlass, SignOut, User } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

export default function TopNav({ onSearch }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const links = [
    { to: "/explore", label: "Explore" },
    { to: "/demo", label: "Demo Mode" },
    { to: "/pricing", label: "Pricing" },
    ...(user ? [{ to: "/saved", label: "Saved" }] : []),
  ];

  return (
    <nav
      data-testid="top-nav"
      className="fixed top-0 left-0 right-0 z-30 h-16 flex items-center justify-between px-5 sm:px-8"
      style={{ background: "rgba(3,3,5,0.6)", backdropFilter: "blur(16px)", borderBottom: "1px solid rgba(255,255,255,0.07)" }}
    >
      <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
        <Atom size={26} weight="duotone" color="#00D8FF" className="group-hover:rotate-45 transition-transform duration-500" />
        <span className="font-display font-bold text-lg tracking-tighter">STELLAR<span className="text-cyan-400">NAV</span></span>
      </Link>

      <div className="hidden md:flex items-center gap-1">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
            className={`px-4 py-2 rounded-full text-sm transition-colors ${
              loc.pathname === l.to ? "text-cyan-300 bg-white/5" : "text-white/60 hover:text-white"
            }`}
          >
            {l.label}
          </Link>
        ))}
      </div>

      <div className="flex items-center gap-2">
        {onSearch && (
          <button data-testid="nav-search" onClick={onSearch} className="p-2.5 rounded-full text-white/70 hover:text-cyan-300 hover:bg-white/5 transition-colors">
            <MagnifyingGlass size={19} weight="duotone" />
          </button>
        )}
        {user ? (
          <div className="flex items-center gap-2 pl-2">
            {user.tier && user.tier !== "public" && (
              <span data-testid="tier-badge" className="hidden sm:inline text-tel text-[8px] px-2.5 py-1 rounded-full capitalize" style={{ background: "rgba(0,216,255,0.15)", color: "#7fe6ff" }}>{user.tier}</span>
            )}
            <div className="hidden sm:flex items-center gap-2 text-white/70 text-sm">
              <User size={16} weight="duotone" color="#00D8FF" />
              <span className="max-w-[120px] truncate">{user.name}</span>
            </div>
            <button data-testid="nav-logout" onClick={() => { logout(); nav("/"); }} className="p-2.5 rounded-full text-white/60 hover:text-red-400 transition-colors">
              <SignOut size={18} weight="duotone" />
            </button>
          </div>
        ) : (
          <Link
            to="/auth"
            data-testid="nav-signin"
            className="ml-1 px-5 py-2 rounded-full text-sm font-semibold bg-cyan-400 text-[#030305] glow-cyan hover:bg-cyan-300 transition-colors"
          >
            Sign In
          </Link>
        )}
      </div>
    </nav>
  );
}
